import {AccountService} from '../../singelton/account.service';
import {FACTOR_WORKFLOW_ROLE_OPTIONS} from '../model/factor-workflow-step-config.model';

export const FACTOR_WF_STEP_ROLES = FACTOR_WORKFLOW_ROLE_OPTIONS.map(option => option.value);

export function canAccessFactorWorkflowKartabl(accountService: AccountService): boolean {
  return accountService.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_GOD_USER'])
    || accountService.hasAnyAuthority(FACTOR_WF_STEP_ROLES);
}

export function canAccessFactorWorkflowAdminMenus(accountService: AccountService): boolean {
  return accountService.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_GOD_USER']);
}
